import { CanvasElementType, CanvasObjectPosition, CanvasObjectSize } from '@y42/json-schema';
import type { VisualizationCanvasElementStoreModel } from '../visualization-canvas-element.model';
import { defaultCanvasGenericStyles, defaultCanvasObjectProperties } from './default-canvas-model-properties';

const canvasAttentionDefaultSize: CanvasObjectSize = {
  width: 50,
  height: 50,
};

export function getCanvasFreeAttentionNodeModel(data: { position: CanvasObjectPosition; attachedTo?: string }) {
  return {
    type: CanvasElementType.FreeAttentionNode,
    position: data.position,
    size: canvasAttentionDefaultSize,
    typeSettings: {
      attachedTo: data.attachedTo,
    },
    styles: { ...defaultCanvasGenericStyles },
    objectProperties: {
      ...defaultCanvasObjectProperties,
      resizable: false,
      selectable: false,
      rotatable: false,
    },
  };
}

export type CanvasFreeAttentionNodeModel = VisualizationCanvasElementStoreModel<CanvasElementType.FreeAttentionNode>;
